import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { useMemo } from 'react';
import { baseURLSelector } from '../../../redux/reducers/app/params';
import { useRandomGameRoute } from '../../useRandomGameRoute';
import {
  NAVBAR_ITEMS,
  ROUTES_WITH_BACK_BUTTON,
} from '../../../constants/navbar';
import { ROOT } from '../../../constants/routeTemplates';

export const useNavbarBackButton = () => {
  const baseUrl = useSelector(baseURLSelector);
  const randomGameRoute = useRandomGameRoute();
  const { path } = useRouteMatch();

  const randomGameFullPath = useMemo(
    () => baseUrl.concat(randomGameRoute),
    [baseUrl, randomGameRoute]
  );

  const rootPath = useMemo(() => baseUrl.concat(ROOT), [baseUrl]);

  const shouldShowButton = ROUTES_WITH_BACK_BUTTON.includes(path);

  return useMemo(() => {
    return shouldShowButton
      ? {
          item: NAVBAR_ITEMS.BACK,
          itemConfig: {
            restrictedPaths: [randomGameFullPath],
            fallbackPaths: [rootPath],
          },
        }
      : null;
  }, [shouldShowButton, randomGameFullPath, rootPath]);
};
